/**
* 基础菜单 动态属性管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>动态属性管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form-item label="">
        <el-input size="small" placeholder="标题" clearable @click="gotoOrderDetail(scope.row.id)"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" placeholder="创建人" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <div class="block">
          <el-date-picker
            v-model="value"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="whole">
      <div class="title_box flex_box bb1" style="width: 100%;">
        <div class="widen_ti fw br1" style="width: 55px;"><p>序号</p></div>
        <div class="widen_ti fw br1" style="min-width: 76%;"><p>标题</p></div>
        <div class="widen_ti fw br1" style="width: 180px;"><p>创建人</p></div>
        <div class="widen_ti fw" style="width: 150px;"><p>创建时间</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>1</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>药品行业管理规范</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>2</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>商家服务管理规范</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>3</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>医疗器械行业管理规范</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>4</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>商家违规作弊管理规则</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>5</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>违规申诉管理规范</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>6</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>关联店铺管理规范</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>7</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>商品价格管理规范</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>8</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>商家入驻标准</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="nr flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>9</p></div>
        <div class="widen br1" style="min-width: 76%;"><p>入驻商店铺类型及命名管理规范</p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>
      <div class="flex_box" style="width: 100%;">
        <div class="widen br1" style="width: 55px;"><p>10</p></div>
        <div class="widen br1" style="min-width: 76%;"><p><el-link :underline="false" @click="goHome">入驻商入驻资质管理规范</el-link></p></div>
        <div class="widen br1" style="width: 180px;"><p>admin</p></div>
        <div class="widen" style="width: 150px;"><p>2023-09-12</p></div>
      </div>

    </div>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="100"
        layout="total, prev, pager, next, jumper"
        :total="1000"
        background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentPage: 1,
        input: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value: '',
      };
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      goHome() {
        localStorage.setItem('path', '/rules/rulesDetails')
        let tag = {
          url: "/rules/rulesDetails",
          menuname: "规则详情"
        }
        this.$router.push({path: '/rules/rulesDetails'})
      },
    },
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  .fw {
    font-weight: bold;
  }

  .flex_box {
    display: flex;
    align-items: center;
  }

  .title_box {
    border-bottom: 1px solid #EBEEF5;
    background: #F5F7FA;
  }

  .widen_ti {
    height: 41px;
  }

  .widen_ti p {
    color: #333;
    font-size: 14px;
    line-height: 25px;
    padding: 8px 10px;
  }

  .widen {
    height: 45px;
  }

  .widen p {
    color: #333;
    font-size: 14px;
    line-height: 23px;
    padding: 11px 10px;
  }

  .whole {
    height: 502px;
    overflow-y: auto;
    border: 1px solid #EBEEF5;
    margin-bottom: 10px;
  }

  .nr {
    border-bottom: 1px solid #EBEEF5;
  }

  .br1 {
    border-right: 1px solid #EBEEF5;
  }


</style>





// WEBPACK FOOTER //
// src/views/rules/rulesInbound.vue